import React from "react";
import PropTypes from "prop-types";
import "./SubHeader.css";

function SubHeader(props) {
  const { clinicName } = props;

  return (
    <div data-testid="sub-header" className="sub-header">
      {clinicName}
    </div>
  );
}

// PropTypesを使ってプロパティの型を定義
SubHeader.propTypes = {
  clinicName: PropTypes.string.isRequired,
};

export default SubHeader;
